import type { FaireProductEntity } from "../../entity_types/product";

export const p_e435yy8scz: FaireProductEntity = {
  token: "p_e435yy8scz",
  type: "product",
  name: "Olive Oil",
  brandToken: "b_2yavxh8gni",
  brandName: "Wonder Valley",
  imageUrl:
    "https://cdn.faire.com/fastly/797828af9b0d1d4446796f0144daddc01154e062c2fda7fad6fd2b9e120a1d23.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/786c2e3d004a946592d10e12fb51ad0d9b46ffeba5815838a1f41eb5875f629e.jpeg",
    "https://cdn.faire.com/fastly/6eab338903e1cf8a9e235cc2760a57632428c3c0a10e1953459def2a9fe9f4df.png",
    "https://cdn.faire.com/fastly/178180516e113a9d7527c6e42d4e033be4997702ba7c841749d90d13b19d8718.jpeg",
    "https://cdn.faire.com/fastly/eaa55406f29ed5df10b5d916824963825621c484180e662aed2c28492fef66c1.jpeg",
    "https://cdn.faire.com/fastly/3333bceca1ab12c0682b766cccb078f9602c488fec9121226633c76811a42a29.png",
    "https://cdn.faire.com/fastly/5a3c32cd3edc1db1cd4c2ff131735b1021a27045fe804f2c6c481c04cb8c01c8.png",
  ],
  priceDollars: 20,
  description:
    "California Extra Virgin Olive Oil High in Polyphenols & Antioxidants\n\nWonder Valley Olive Oil is a cook's best friend. This beautiful bottle of California extra virgin olive oil has a smooth, verdant flavor and elevates everyday cooking and eating.  Well-suited to all kinds of cooking demands, but just as delicious simply mopped up by a crusty loaf of bread. This timeless superfood delivers a delicious dose of polyphenols, the powerful antioxidant associated with longevity of life. Hand-picked from the sunny groves in Northern California's Lake County and pressed within hours of harvest by a master miller.\n\nFlavor Profile\n• Green Tea, Cut Grass, Apricot with a strong pepper finish\n\nOlive Varietals\n• Frantoio, Leccino, Arbequina, and Favolosa \n\nHarvest Date\n• November 2025\n\nPolyphenol Count\n• 334\n\nHealth Benefits\n• Omega 3 Essential Fatty Acids \n• Polyphenols (Antioxidants) \n• Phenolic Compounds\n• Oleic Acid\n• Vitamin E\n\nSize\n• 375 mL / 12.7 oz ",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:53.555Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
